import API from './config'

export const CityAPI = {
    async getCitByCityNameAndUf(city_name, uf) {
        try {

            const response = await API.post('/citys/getCityId', {
                city_name: city_name.toUpperCase(),
                uf: uf,
            })

            const filteredSameName = response.data.rows.filter(el => el.city_name === city_name);
            if (response.data
                && response.data.rows
                && (
                    response.data.rows.length == 1
                    || (city_name.includes("UF_RPPS") && filteredSameName.length === response.data.rows.length)
                )) {

                return {
                    success: true,
                    body: response.data.rows[0]
                };
            } else {

                return {
                    success: false,
                    body: "Erro na obtenção do id da cidade"
                };
            }



        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }


    }
}

